<template>
  <b-modal
    ref="modal"
    :cancel-variant="data.cancelVariant || undefined"
    :header-bg-variant="data.headerBgVariant || undefined"
    :footer-bg-variant="data.footerBgVariant || undefined"
    :header-text-variant="data.headerTextVariant || undefined"
    title-tag="div"
    footer-class="d-none"
    :dialog-class="data.dialogClass"
    :content-class="data.contentClass"
    :body-class="data.bodyClass"
    :size="data.size || 'md'"
    :centered="data.centered || false"
    :scrollable="false"
    :no-close-on-backdrop="data.noCloseOnBackdrop || false"
    :no-close-on-esc="data.noCloseOnEsc || false"
    :hide-header-close="data.hideHeaderClose || false"
    :hide-header="data.hideHeader || false"
    @hide="hide"
    @hidden="onClose"
    @shown="onShow"
  >
    <template slot="modal-header-close">
      <b-button
        size="sm"
        variant="primary"
        class="ni ni-close"
        @click="close()"
      >
      </b-button>
    </template>
    <template v-slot:modal-title>
      <div v-html="data.title"></div>
    </template>
    <!--<component v-if="isShown" v-bind:is="data.component" v-bind="data.componentData" v-on:[data.componentEvents]="test"></component>-->
    <component
      :is="data.component"
      v-if="isShown"
      v-bind="data.componentData"
      v-on="eventsToBind"
    ></component>
  </b-modal>
</template>
<script>
import modal from "@dialogs/modal.vue";
import Vue from 'vue';
import { customImport } from "@/utils";

export default {
    mixins: [modal],
    data() {
        return {
            isShown: false,
            eventsToBind: {}
        }
    },
    methods: {
        onShow () {
            if(!this.data.component)
                throw 'Missing component name';

            if(!this.data.componentData)
                console.warn('Missing component data');

            if(this.$options.components[this.data.component]) {
                this.bindEvents();
                this.isShown = true;
            } else {
                customImport('comp/'+ this.data.component).then(comp => {
                    this.$options.components[this.data.component] = comp.default;
                    this.bindEvents();
                    this.isShown = true;
                }).catch(err => {
                    console.error(err);
                    this.response = err;
                    this.close();
                });
            }
        },
        onClose() {
            this.events = {};
            this.isShown = false;
        },
        handleEvent(eventName, data) {
            this.response.event = eventName;
            this.response.data = data;
            this.close(1);
        },
        bindEvents() {
            let self = this;
            if(this.data.componentEvents && this.data.componentEvents.length > 0) {
                for(let i=0; i<this.data.componentEvents.length; i++) {
                    this.eventsToBind[this.data.componentEvents[i]] = (data) => {
                        self.handleEvent(self.data.componentEvents[i], data)
                    };
                }
            }
        }
    }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/app/dialogs/modalComponent.vue